import { render } from "./CollectibleEditModalPopup.vue?vue&type=template&id=5616f595&scoped=true"
import script from "./CollectibleEditModalPopup.vue?vue&type=script&lang=js"
export * from "./CollectibleEditModalPopup.vue?vue&type=script&lang=js"

import "./CollectibleEditModalPopup.vue?vue&type=style&index=0&id=5616f595&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5616f595"]])

export default __exports__